{
  "fr": {
    "timestamp": {
      "labels": {
        "accepted": "Accepté {date}",
        "ago": "il y a",
        "daysAgo": "{days} jour |{days} jours",
        "daysRemaining": "{days} jours restants",
        "due": "Echéance: {date}",
        "dueToday": "Aujourd'hui",
        "expired": "Expiré {date}",
        "hoursAgo": "{hours} heure | {hours} heures",
        "in": "Dans {time}",
        "justNow": "Maintenant",
        "minutesAgo": "{minutes} minute | {minutes} minutes",
        "monthsAgo": "{months} mois | {months} mois",
        "noDeadline": "Aucun délai fixé",
        "overdue": "En retard avec {days} jours",
        "sentOn": "Envoyé le {date}",
        "sentOnAt": "Envoyé le {date} à {time}",
        "starts": "Départ: {date}",
        "today": "Aujourd'hui",
        "tomorrow": "Demain",
        "uploaded": "Téléchargé {date}",
        "weeksAgo": "{weeks} semaine | {weeks} semaines",
        "yearsAgo": "{years} année | {years} années",
        "yesterday": "Hier"
      }
    }
  }
}